import React, { FC } from 'react';
import classnames from 'classnames';
import { IListProps } from '../interface';
import Virtual from './Virtual';
import { Spin } from '@firesoon/antd';

const List: FC<IListProps> = ({ virtual, data, className, renderItem, children, loading = false, ...rest }) => {
  return (
    <Spin spinning={loading}>
      <div className={classnames('fs-list', className)} {...rest}>
        {(() => {
          /** 虚拟列表 */
          if (virtual) {
            return <Virtual data={data} renderItem={renderItem} {...virtual} />;
          }
          return data?.map((item, index) => renderItem(item, index));
        })()}
        {children}
      </div>
    </Spin>
  );
};

export default List;
